import { FrequencyFormattingConstants } from '../../../../core/services/frequency-formatting/frequency-formatting-constants';

/**
 * Mask configurations used in the [mask] directive for frequencies.
 * Documentation: https://imask.js.org/guide.html
 */
export class FrequencyMaskConfig {
    public static readonly frequency = {
        mask: Number,
        scale: FrequencyFormattingConstants.frequencyDecimalPlaces,
        signed: false,
        thousandsSeparator: '',
        padFractionalZeros: true,
        normalizeZeros: true,
        min: 0,
        max: 99999.99999,
        radix: '.',
        lazy: false,
    };

    public static readonly power = {
        mask: Number,
        scale: 3,
        signed: false,
        thousandsSeparator: '',
        padFractionalZeros: false,
        normalizeZeros: true,
        min: 0,
        max: 999999999999.999,
        radix: '.',
        lazy: false,
    };
}
